import { api } from '@/lib/api/client';

/**
 * El cierre del evento (migración 121): lo que queda en las estaciones vuelve
 * al inventario y queda un acta. Refleja `ClosingStatus` del backend.
 */
export interface ClosingLine {
  stationId: number;
  stationName: string;
  stockId: number;
  stockName: string;
  stockImage: string | null;
  unitCost: number | null;
  allocationIds: number[];
  allocated: number;
  inPlay: number;
  won: number;
  delivered: number;
  pending: number;
  expired: number;
  voided: number;
  /** Lo que debería haber físicamente: en juego más caducados y anulados. */
  onHand: number;
  counted: number;
  returned: number;
  restocked: number;
  unaccounted: number;
}

export interface ClosingTotals {
  allocated: number;
  inPlay: number;
  delivered: number;
  pending: number;
  expired: number;
  voided: number;
  counted: number;
  returned: number;
  restocked: number;
  unaccounted: number;
  distributedValue: number | null;
}

export interface ClosingStatus {
  event: { id: number; name: string; endDate: string | null; eventStatus: string | null };
  ended: boolean;
  closing: { id: number; closedAt: string; closedBy: string | null; note: string | null; totals: ClosingTotals } | null;
  lines: ClosingLine[];
  totals: ClosingTotals;
}

export interface CloseInput {
  note?: string;
  counts?: Array<{ stationId: number; stockId: number; counted: number }>;
}

export const closingApi = {
  status: (eventId: number) => api.get<ClosingStatus>(`/xk-event/${eventId}/closing`),
  close: (eventId: number, input: CloseInput) => api.post<ClosingStatus>(`/xk-event/${eventId}/closing`, input),
  reopen: (eventId: number) => api.delete<ClosingStatus>(`/xk-event/${eventId}/closing`),
};
